// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.voucher-manager {
  padding: 10px;
}
.voucher-manager .total-label {
  display: inline-block;
  width: 240px;
}
.voucher-manager .total-price {
  display: inline-block;
  width: 80px;
  text-align: right;
  margin-right: 10px;
}
.voucher-manager .total-label.sum, .voucher-manager .total-price.sum {
  font-weight: bold;
}
.voucher-manager .select-date {
  width: 100%;
  text-align: center;
  margin-top: 20px;
}
.voucher-manager .select-date .day-count {
  font-size: 15px;
  width: 40px;
  height: 30px;
  text-align: center;
  margin-right: 2px;
  border-radius: 5px;
  border-bottom: 1px solid white;
}
.voucher-manager .income {
  display: block;
  margin: auto;
  width: 720px;
  margin-top: 10px;
  position: relative;
  max-height: 0;
  overflow: hidden;
  transition: 300ms;
}
.voucher-manager .show-income {
  max-height: 200px;
  transition: 300ms;
}
.voucher-manager .voucher-header {
  margin-top: 30px;
}
.voucher-manager .header-item {
  margin-right: 10px;
}
.voucher-manager .header-item svg-icon {
  line-height: 30px;
  vertical-align: middle;
  margin-right: 4px;
}
.voucher-manager .header-item.action {
  cursor: pointer;
}
.voucher-manager .list-voucher-child {
  background-color: rgba(41, 41, 131, 0.3);
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/voucher-manager/voucher-manager.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;AACI;EACI,qBAAA;EACA,YAAA;AACR;AAEI;EACI,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AAAR;AAGI;EACI,iBAAA;AADR;AAII;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;AAFR;AAIQ;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,8BAAA;AAFZ;AAMI;EACI,cAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;AAJR;AAOI;EACI,iBAAA;EACA,iBAAA;AALR;AAQI;EACI,gBAAA;AANR;AASI;EACI,kBAAA;AAPR;AASQ;EACI,iBAAA;EACA,sBAAA;EACA,iBAAA;AAPZ;AAWI;EACI,eAAA;AATR;AAYI;EACI,wCAAA;AAVR","sourcesContent":[".voucher-manager {\n    padding: 10px;\n\n    .total-label {\n        display: inline-block;\n        width: 240px;\n    }\n\n    .total-price {\n        display: inline-block;\n        width: 80px;\n        text-align: right;\n        margin-right: 10px;\n    }\n\n    .total-label.sum, .total-price.sum {\n        font-weight: bold;\n    }\n\n    .select-date {\n        width: 100%;\n        text-align: center;\n        margin-top: 20px;\n\n        .day-count {\n            font-size: 15px;\n            width: 40px;\n            height: 30px;\n            text-align: center;\n            margin-right: 2px;\n            border-radius: 5px;\n            border-bottom: 1px solid white;\n        }\n    }\n\n    .income {\n        display: block;\n        margin: auto;\n        width: 720px;\n        margin-top: 10px;\n        position: relative;\n        max-height: 0;\n        overflow: hidden;\n        transition: 300ms;\n    }\n\n    .show-income {\n        max-height: 200px;\n        transition: 300ms;\n    }\n\n    .voucher-header {\n        margin-top: 30px;\n    }\n\n    .header-item {\n        margin-right: 10px;\n\n        svg-icon {\n            line-height: 30px;\n            vertical-align: middle;\n            margin-right: 4px;\n        }\n    }\n\n    .header-item.action {\n        cursor: pointer;\n    }\n\n    .list-voucher-child {\n        background-color: rgba(41,41,131,0.3);\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
